import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import Adminnavbar from "../Adminnavbar";

export default function CalendarCreate() {
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const dayMonthRegex =
    /^(0?[1-9]|[12][0-9]|3[01])-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)$/i;

  const [errors, setErrors] = useState({
    period: false,
    dueDate: false,
  });

  const [data, setData] = useState({});

  const formatDayMonth = (value) => {
    const [day, month] = value.split("-");
    if (!day || !month) return value;
    return `${day}-${month.charAt(0).toUpperCase()}${month
      .slice(1)
      .toLowerCase()}`;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // auto-format (25-dec → 25-Dec)
    const formattedValue =
      name === "period" || name === "dueDate" ? formatDayMonth(value) : value;

    setData((prev) => ({
      ...prev,
      [name]: formattedValue,
    }));

    // validation only for period & dueDate
    if (name === "period" || name === "dueDate") {
      setErrors((prev) => ({
        ...prev,
        [name]: formattedValue !== "" && !dayMonthRegex.test(formattedValue),
      }));
    }
  };

  // ================= SUBMIT =================
  const handleSubmit = async (e) => {
    e.preventDefault();

    const { compliance, category, applicability, period, dueDate, act, notes } =
      data;

    // VALIDATION
    if (
      !compliance ||
      !category ||
      !applicability ||
      !period ||
      !dueDate ||
      !act ||
      !notes
    ) {
      Swal.fire({
        title: "All fields are required",
        icon: "warning",
      });
      return;
    } else if (errors.period || errors.dueDate) {
      Swal.fire({
        title: "Please fix date format",
        icon: "warning",
      });
      return;
    }
    try {
      setLoader(true);
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/calendar/store`,
        data
      );

      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Date Created Successfully",
          timer: 1500,
        }).then(() => navigate("/calendar-list"));
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "Something went wrong!",
        icon: "error",
      });
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <Adminnavbar />

      {loader ? (
        <div className="text-center mt-5">Loading...</div>
      ) : (
        <div className="page-wrapper">
          <div className="content">
            <form onSubmit={handleSubmit}>
              <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admindashbord">Dashboard</Link> /
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/calendar-list">Calendar</Link> /
                  </li>
                  <li className="breadcrumb-item active">Add Calendar Date</li>
                </ol>
              </nav>

              <div className="content-page-header">
                <h5>Add Calendar Date</h5>
              </div>

              <div className="row">
                <div className="col-lg-4">
                  <label>Compliance</label>
                  <input
                    type="text"
                    name="compliance"
                    className="form-control"
                    value={data.compliance}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-lg-3">
                  <label>Category</label>
                  <select
                    name="category"
                    className="form-control"
                    value={data.category}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Category</option>
                    <option value="GST">GST</option>
                    <option value="TDS">TDS</option>
                    <option value="ROC">ROC</option>
                    <option value="Income Tax">Income Tax</option>
                  </select>
                </div>

                <div className="col-lg-4">
                  <label>Applicability</label>
                  <input
                    type="text"
                    name="applicability"
                    className="form-control"
                    value={data.applicability}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-lg-4 mt-3">
                  <label>Act</label>
                  <input
                    type="text"
                    name="act"
                    className="form-control"
                    value={data.act}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-lg-3 mt-3">
                  <label>Period</label>
                  <input
                    type="text"
                    name="period"
                    placeholder="DD-MMM (25-Dec)"
                    className={`form-control ${
                      errors.period ? "is-invalid" : ""
                    }`}
                    value={data.period}
                    onChange={handleInputChange}
                  />
                  {errors.period && (
                    <small className="text-danger">
                      Use DD-MMM format (example: 25-Dec)
                    </small>
                  )}
                </div>
                <div className="col-lg-3 mt-3">
                  <label>Due Date</label>
                  <input
                    type="text"
                    name="dueDate"
                    placeholder="DD-MMM (01-Jan)"
                    className={`form-control ${
                      errors.dueDate ? "is-invalid" : ""
                    }`}
                    value={data.dueDate}
                    onChange={handleInputChange}
                  />
                  {errors.dueDate && (
                    <small className="text-danger">
                      Use DD-MMM format (example: 01-Jan)
                    </small>
                  )}
                </div>

                <div className="col-lg-5 mt-3">
                  <label>Notes</label>
                  <textarea
                    type="text"
                    name="notes"
                    className="form-control"
                    value={data.notes}
                    onChange={handleInputChange}
                  />
                </div>

                {/* Buttons */}
                <div className="col-lg-12 mt-4">
                  <div className="btn-path">
                    <Link to={"/calendar-list"} className="btn btn-cancel me-3">
                      Back
                    </Link>
                    <button type="submit" className="btn btn-submit">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
